import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Badge } from "reactstrap";
import { getStatusColor } from "./status-colors";

export { getStatusColor };

// Icono por defecto según el color del estado; `icon` lo reemplaza.
const DEFAULT_ICONS = {
  success: "fa-check-circle",
  danger: "fa-times-circle",
  warning: "fa-clock-o",
  info: "fa-info-circle",
  primary: "fa-circle",
  secondary: "fa-minus-circle",
  dark: "fa-circle",
};

/**
 * Estado del sistema: pill de color con icono y ancho mínimo uniforme.
 * Estilos globales en scss/dhn/_status-badge.scss. Sin `color`, el color se
 * toma del nombre del estado (status-colors.js).
 *
 * <StatusBadge>Despachada</StatusBadge>
 * <StatusBadge color="success">Aprobada</StatusBadge>
 * <StatusBadge color="secondary" icon="fa-minus-circle">No requiere</StatusBadge>
 */
export default function StatusBadge({ children, className, color, icon, title }) {
  const badgeColor =
    color || (typeof children === "string" ? getStatusColor(children) : "secondary");
  const iconClass = icon || DEFAULT_ICONS[badgeColor] || DEFAULT_ICONS.secondary;

  return (
    <Badge
      pill
      color={badgeColor}
      title={title}
      className={classnames("dhn-status-badge", className)}
    >
      <i className={classnames("fa", iconClass)} aria-hidden="true"></i>
      <span>{children}</span>
    </Badge>
  );
}

StatusBadge.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  color: PropTypes.oneOf(Object.keys(DEFAULT_ICONS)),
  icon: PropTypes.string,
  title: PropTypes.string,
};
